import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';

import styles from './style.scss';


const BookCover = ({
  book, isActiveItem, linkCallback,
  showSubscription, isAudioBook, height,
  width, isAvailableOnlyUser, isNotAvailableForUser,
}) => {
  const mainAuthor = book.main_author;

  // null as default value for free books
  const subscriptionId = book.subscription_id || 0;
  const subscriptionType = ['free', 'standard', 'premium'][subscriptionId];

  const classList = [
    styles.book,
    showSubscription && !isAudioBook ? styles[subscriptionType] : '',
    isAudioBook ? styles.isAudioBook : '',
    isActiveItem ? styles.isActive : '',
    isAvailableOnlyUser ? 'jest-book-available-only-user' : '',
    'jest-book-cover',
  ];

  const alt = mainAuthor ? `${mainAuthor.cover_name} - ${book.name}` : book.name;
  let attentionText = isAvailableOnlyUser
    ? `Успейте ${isAudioBook ? 'послушать' : 'прочитать'}`
    : null;

  if (isNotAvailableForUser) {
    attentionText = 'Книга недоступна';
  }

  return (
    <div className={classNames(classList)} style={{ width: `${width}px`, height: `${height}px` }} >
      <Link to={book.getLink()} onClick={linkCallback ? () => linkCallback(book) : null}>
        {(attentionText || isNotAvailableForUser) && (
          <div className={styles.bookAvailableAttention}>
            <span>
              {attentionText}
            </span>
          </div>
        )}
        <CroppedImage
          src={book.default_cover}
          alt={alt}
          height={height}
          width={width}
          className={isAudioBook ? styles.audioBookImage : styles.bookImage} />
      </Link>
    </div>
  );
};

BookCover.propTypes = {
  book: PropTypes.shape({
    default_cover: PropTypes.string,
    absolute_url: PropTypes.string,
    name: PropTypes.string,
    main_author: PropTypes.shape({
      cover_name: PropTypes.string,
    }),
  }).isRequired,
  isActiveItem: PropTypes.bool,
  showSubscription: PropTypes.bool,
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  isAudioBook: PropTypes.bool,
  isAvailableOnlyUser: PropTypes.bool,
  isNotAvailableForUser: PropTypes.bool,
};

BookCover.defaultProps = {
  showSubscription: false,
  height: 128,
  width: 88,
  isAudioBook: false,
  isAvailableOnlyUser: false,
  isNotAvailableForUser: false,
};

export default BookCover;
